import { render, staticRenderFns } from "./DeliveryTimeDialog.vue?vue&type=template&id=1d3e66f0&scoped=true&"
import script from "./DeliveryTimeDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveryTimeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e66f0",
  null
  
)

export default component.exports